import React, { createContext, useContext, useState } from 'react';
import { ThemeProvider } from 'styled-components';

import theme from '../../styles/defaultTheme';

const GlobalContext = createContext({});

export function useGlobal() {
    const context = useContext(GlobalContext);

    return context;
}

export function GlobalProvider({ children }) {
    const [contrastTheme, setContrastTheme] = useState(false);
    const [dataLogin, setDataLogin] = useState({});
    const [contractsGroupsList, setContractsGroupsList] = useState([]);
    const [contractsList, setContractsList] = useState([]);
    const [contractGroupSelected, setContractGroupSelected] = useState();
    const [dataActiveContract, setDataActiveContract] = useState({});
    const [staticOptions, setStaticOptions] = useState({});
    const [useAllContracts, setUseAllContracts] = useState(false);
    const [showSupportModal, setShowSupportModal] = useState(false);

    return (
        <ThemeProvider theme={contrastTheme ? theme.contrast : theme.colorsNormal}>
            <GlobalContext.Provider
                value={{
                    dataLogin,
                    setDataLogin,
                    contractsGroupsList,
                    setContractsGroupsList,
                    contractsList,
                    setContractsList,
                    dataActiveContract,
                    setDataActiveContract,
                    staticOptions,
                    setStaticOptions,
                    contrastTheme,
                    setContrastTheme,
                    useAllContracts,
                    setUseAllContracts,
                    contractGroupSelected,
                    setContractGroupSelected,
                    showSupportModal,
                    setShowSupportModal,
                }}
            >
                {children}
            </GlobalContext.Provider>
        </ThemeProvider>
    );
}
